module.exports = __webpack_public_path__ + "static/media/spiked-dragon-head.8471bf69.svg";